import { fabric } from 'fabric';

export function createFabricCanvas(id, width, height) {
    return new fabric.Canvas(id, { width, height });
}

export function createFabricTextObject(text, options = {}) {
    return new Promise((resolve, reject) => {
        const textObject = new fabric.Text(text, options);
        resolve(textObject);
    });
}

export function createFabricImageObjectFromSrc(src, options = {}) {
    return new Promise((resolve, reject) => {
        fabric.Image.fromURL(src, imageObject => {
            imageObject.set(options);
            resolve(imageObject);
        });
    });
}

export function deleteFabricCanvas(fabricCanvasObject) {
    fabricCanvasObject.clear();
    fabricCanvasObject.dispose();
}
